/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: ClRepu2PwVaX

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { RawTr } from "@myevaluations/myevals-plasmic-utils/dist/code-components/RawTable/Tr"; // plasmic-import: vCL1fk0Bw_QR/codeComponent
import TableTd from "../../TableTd"; // plasmic-import: yk0RhbxcMVQJ/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicTableTr.module.css"; // plasmic-import: ClRepu2PwVaX/css

createPlasmicElementProxy;

export type PlasmicTableTr__VariantMembers = {};
export type PlasmicTableTr__VariantsArgs = {};
type VariantPropType = keyof PlasmicTableTr__VariantsArgs;
export const PlasmicTableTr__VariantProps = new Array<VariantPropType>();

export type PlasmicTableTr__ArgsType = { children?: React.ReactNode };
type ArgPropType = keyof PlasmicTableTr__ArgsType;
export const PlasmicTableTr__ArgProps = new Array<ArgPropType>("children");

export type PlasmicTableTr__OverridesType = {
  root?: Flex__<typeof RawTr>;
};

export interface DefaultTableTrProps {
  children?: React.ReactNode;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicTableTr__RenderFunc(props: {
  variants: PlasmicTableTr__VariantsArgs;
  args: PlasmicTableTr__ArgsType;
  overrides: PlasmicTableTr__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <RawTr
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "__wab_instance",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      {renderPlasmicSlot({
        defaultContents: (
          <React.Fragment>
            <TableTd
              className={classNames("__wab_instance", sty.tableTd__kN4Xg)}
            />

            <TableTd
              className={classNames("__wab_instance", sty.tableTd__u6Ldr)}
            />

            <TableTd
              className={classNames("__wab_instance", sty.tableTd__fhlOq)}
            />

            <TableTd
              className={classNames("__wab_instance", sty.tableTd__si7In)}
            />
          </React.Fragment>
        ),
        value: args.children
      })}
    </RawTr>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: typeof RawTr;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicTableTr__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicTableTr__VariantsArgs;
    args?: PlasmicTableTr__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicTableTr__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicTableTr__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTableTr__ArgProps,
          internalVariantPropNames: PlasmicTableTr__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTableTr__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicTableTr";
  } else {
    func.displayName = `PlasmicTableTr.${nodeName}`;
  }
  return func;
}

export const PlasmicTableTr = Object.assign(
  // Top-level PlasmicTableTr renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements

    // Metadata about props expected for PlasmicTableTr
    internalVariantProps: PlasmicTableTr__VariantProps,
    internalArgProps: PlasmicTableTr__ArgProps
  }
);

export default PlasmicTableTr;
/* prettier-ignore-end */
